import React from 'react';
import InvestLanding from './InvestLanding';
export default function App() { return <InvestLanding />; }
